import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useSyncCalendars } from 'src/modules/calendar/hooks/use-sync-calendars'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'
import { CalendarDto } from 'src/types/calendar.dto'

type UseCalendarsOptions = { sync: boolean } & UseQueryOptions<CalendarDto[]>

export const GET_CALENDARS_CACHE_KEY = 'get-calendars'

export function useCalendars(_params?: {}, options: UseCalendarsOptions = { sync: false }) {
  const handleRetry = useHandleRetry()
  const syncCalendars = useSyncCalendars()

  const { sync, ...restOptions } = options

  return useQuery(
    GET_CALENDARS_CACHE_KEY,
    async () => {
      if (sync) await syncCalendars.mutateAsync()
      return ApiService.Calendars.getCalendars()
    },
    {
      staleTime: ms('5m'),
      retry: handleRetry,
      ...restOptions,
    },
  )
}
